import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=87079558&scoped=true"
var script = {}
import style0 from "./Marketing.vue?vue&type=style&index=0&id=87079558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87079558",
  null
  
)

export default component.exports